import {
    Col, List, Row, Typography, Image,
} from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import IMAGES from '../../../constants/images';

const { Title, Text } = Typography;

const Parameters = () => {
    const { t } = useTranslation('home', { keyPrefix: 'PARAMETERS' });

    const items: String[] = [
        'PARAGRAPH_1',
        'PARAGRAPH_2',
        'PARAGRAPH_3',
        'PARAGRAPH_4',
        'PARAGRAPH_5',
        'PARAGRAPH_6',
    ];

    return (
        <div className="section__training" id="parameters">
            <Title level={2}>
                {t('PARAMETERS')}
            </Title>
            <div className="section__training--information-line" />
            <div className="section__training--information">
                <Row className="full__width full__height">
                    <Col
                        xs={24}
                        xl={12}
                        className="section__training--information-container"
                    >
                        <Image
                            className="image-left"
                            preview={false}
                            src={IMAGES.illustrations.lighthouse_parameters}
                            height="100%"
                            width="100%"
                        />
                    </Col>
                    <Col xs={24} xl={12} className="section__training--information-text">
                        <List
                            split={false}
                            dataSource={items}
                            renderItem={(item, index) => (
                                <List.Item key={index}>
                                    <Text>
                                        <Trans
                                            t={t}
                                            i18nKey={`${item}`}
                                            components={{
                                                i: <i />,
                                                b: <b style={{ color: '#1E3A90' }} />,
                                                u: <u style={{ color: '#1E3A90' }} />,
                                            }}
                                        />
                                    </Text>
                                </List.Item>
                            )}
                        />
                    </Col>
                </Row>
            </div>

        </div>
    );
};

export default Parameters;
